export function getPriceWithoutTaxes({
  price,
  taxAmount,
}: {
  price: number
  taxAmount: number
}): string {
  return ((price * 100) / (100 + taxAmount * 100)).toFixed(2)
}
